module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h4', {
    staticClass: "chapter"
  }, [_vm._v("HALF A")]), _vm._v(" "), _c('h5', {
    staticClass: "chapter"
  }, [_vm._v("CROWN")]), _vm._v(" "), _c('p', {
    staticClass: "center01"
  }, [_vm._v("Jo Walton"), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center03"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("A TOM DOHERTY ASSOCIATES BOOK")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9781429954631_L01.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a5fec0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781429954631_epub_tp_r1.vue
// module id = 57
// module chunks = 0